import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useState, useEffect } from "react";
import { Form } from "../shared/Form";
import { registerBankAccountData } from "@/Api/bankAccounts";

interface AddBtnProps {
  updateFront: (callback: (prev: any) => any) => void;
}

export function AddBtn({ updateFront }: AddBtnProps) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      // Reset form state
    }
  }, [open]);

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);

      const payload = {
        name: values?.name,
        surname: values?.surname,
        bank_id: values?.bank_id,
        agency: values?.agency,
        account_number: values?.account_number,
        bank_account_type_id: values?.bank_account_type_id,
        unity_id: values?.unity_id,
      };

      const { data, ok } = await registerBankAccountData(payload);

      if (ok) {
        toast.success(data?.message || "Conta bancária criada com sucesso!");

        updateFront((prev) => ({
          ...prev,
          data: [data.response, ...(prev?.data || [])],
        }));

        setOpen(false);
      }
    } catch (error) {
      console.error(error);
      toast.error("Ocorreu um erro ao processar sua solicitação.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-primary hover:bg-primary/80">
          <Plus className="mr-2 h-4 w-4" /> Criar
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px]">
        <Form
          title="Criar Conta Bancária"
          loading={loading}
          onSubmit={handleSubmit}
          buttonText="Criar"
        />
      </DialogContent>
    </Dialog>
  );
} 